import CloseLineIcon from '@ben/icons/close-line';
import IconButton from '@ben/orion/icon-button';
import Input from '@ben/orion/input';
import Typography, { TypographyVariant } from '@ben/orion/typography';
import { Controller } from 'react-hook-form';
import { FormContainer, FormRow, Spacer } from './styles';
import type { BaseRestrictionFormProps } from './types';

const LifeEventLimitForm = ({
  index,
  control,
  restrictionSetPath,
  onRemove,
}: BaseRestrictionFormProps) => {
  const basePath = `${restrictionSetPath}.lifeEventLimits.${index}`;

  return (
    <FormContainer>
      <FormRow>
        <Typography variant={TypographyVariant.bodyMd1}>
          #{index + 1} :
        </Typography>
        <Typography variant={TypographyVariant.bodyMd1}>
          A maximum of
        </Typography>
        <Controller
          control={control}
          name={`${basePath}.maxLifeEventChanges`}
          rules={{ required: true, min: 0 }}
          render={({ field }) => (
            <Input
              {...field}
              name="Max life event changes"
              type="number"
              showLabel={false}
              width="60px"
              min={0}
            />
          )}
        />
        <Typography variant={TypographyVariant.bodyMd1}>
          life event changes allowed per policy year
        </Typography>
        <Spacer />
        <IconButton
          icon={CloseLineIcon}
          size="sm"
          onClick={onRemove}
          aria-label="Remove restriction"
          variant="action"
        />
      </FormRow>
    </FormContainer>
  );
};

export default LifeEventLimitForm;
